import { Checkbox } from "antd";
import { dontShowTutorialStorageKeyName } from "../../util/constants";
import {
  isLocalStorageAvailable,
  tryGetFromStorage,
  trySetInStorage,
} from "../../util/general";

function DontShowAgain({
  storageKey = dontShowTutorialStorageKeyName,
  children,
}) {
  const localStorageAvailable = isLocalStorageAvailable();
  const initialValue = tryGetFromStorage(storageKey);
  const onChange = (e) => {
    trySetInStorage(storageKey, e.target.checked);
  };
  return !localStorageAvailable ? null : (
    <Checkbox onChange={onChange} defaultChecked={initialValue}>
      {children}
    </Checkbox>
  );
}

export default DontShowAgain;
